module.exports = __webpack_public_path__ + "static/img/open-gold.0ebbc6a4.png";